/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
import Vue from 'vue'
import Vuex from 'vuex'
import schedule from './schedule'
import pool from './pool'
import vehicle from './vehicle'
import geofence from './geofence'
import user from './user'
import assets from './assets'
import books from './books'
import email_template from './email_template'
import router from '../router'
import api, { isSessionExpired } from '../api'

const STORAGE_NAME = `carpool_${process.env.VUE_APP_WEB}`;

Vue.use(Vuex)
Vue.config.devtools = true

const qs = require('qs')

export default new Vuex.Store({
	modules: {
    schedule,
    pool,
    vehicle,
    geofence,
    user,
    assets,
    books,
    email_template,
  },
  state: {
    user: [],
    token: null,
    name: null,
    clientid: null,
    user_id: null,
    type: null,
    error: false,
    errorMsg: null,
    logout_from_button: false,
  },
  getters: {
    getUserData(state) {
      return state.user
    },
    getError(state) {
      return state.error
    },
    getErrorMsg(state) {
      return state.errorMsg
    }
  },
  mutations: {
    ADD_USER_DATA(state, data) {
      state.user = data
    },
    SET_DATA(state, data) {
      state.token = data.token
      state.clientid = data.user.clientid
      state.name = data.user.username
      state.user_id = data.user.id
      state.type = data.user.type
      state.metadata = data.user.metadata
    },
    REMOVE_DATA(state) {
      state.token = null
      state.clientid = null
      state.name = null
      state.user_id = null
      state.type = null
      state.errorMsg = null
    },
    ERROR_STATUS(state, data) {
      state.error = data
    },
    ERROR_MSG(state, data) {
      state.errorMsg = data
    },
    SET_LOGOUT_FROM_BUTTON(state, logout_from_button) {
      state.logout_from_button = logout_from_button
    },
  },
  actions: {
    LOGIN_USER(context, payloads) {
      const {
        username,
        password,
      } = payloads;
      return api.post(`${process.env.VUE_APP_API_URL}/login`, qs.stringify({
        username,
        password
      }))
        .then(
          (response) => {
            const userData = response.data.data.user;
            if (userData.status == 0) {
              context.commit('ERROR_STATUS', true)
              context.commit('ERROR_MSG', "This user has not been approved, please contact the admin")
            } else if (userData.status == 2) {
              context.commit('ERROR_STATUS', true)
              context.commit('ERROR_MSG', "This user is disabled, please contact the admin")
            }
            else if (userData.status == 6) {
              context.commit('ERROR_STATUS', true)
              context.commit('ERROR_MSG', "This user is not found, please contact the admin")
            } else {
              return new Promise((resolve, reject) => {
                try {
                  localStorage.setItem(`USER_DATA_${STORAGE_NAME}`, JSON.stringify({
                    token: response.data.data.token,
                    user_id: userData.id,
                    user: {
                      username: userData.username,
                      type: userData.type,
                      clientid: userData.clientid,
                    },
                    response_login: response.data.data,
                  }))
                } catch (e) {}
                resolve();
              })
              .then(() => {
                context.commit('ERROR_STATUS', false)
                context.commit('SET_DATA', response.data.data)
                context.commit('ADD_USER_DATA', response.data.data)
                router.push({ path:'/book' })
                location.reload();
              })
            }
          }
        )
        .catch((error) => {
          // Bad credentials are a 401 and an unknown account a 404. Both used to
          // arrive as a resolved response, and the 404 branch then read .user off
          // the error payload and threw before anything was shown to the user.
          context.commit('ERROR_STATUS', true)
          context.commit('ERROR_MSG', error.message)
        })
    },
    LOGOUT(context, payloads) {
      const {
        token
      } = payloads;
      return api.post(`${process.env.VUE_APP_API_URL}/logout`, qs.stringify({
        token
      }))
        .then(
          () => {
            return new Promise((resolve, reject) => {
              try {
                localStorage.removeItem(`USER_DATA_${STORAGE_NAME}`)
              } catch (e) {}
              resolve();
            })
            .then(
              () => {
                context.commit('ERROR_STATUS', false)
                context.commit('REMOVE_DATA')
              }
            )
          }
        )
        .catch((error) => {
          context.commit('ERROR_STATUS', true)
          context.commit('ERROR_MSG', error.message)
        })
    },
    LOAD_TOKEN({ commit, dispatch }) {
      if (localStorage.getItem('vuex')) {
        localStorage.removeItem('vuex');
      }
      return new Promise((resolve, reject) => {
        let userData = '';
        try {
          userData = localStorage.getItem(`USER_DATA_${STORAGE_NAME}`)
        } catch (e) {}
        resolve(userData);
      })
      .then((userData) => {
        if (!userData) return
        userData = JSON.parse(userData)
        if (!userData.hasOwnProperty('response_login')) {
          return dispatch('LOGOUT', { token: userData.token }).then(() => {
            router.push({ path: '/login' });
            location.reload();
          })
        }
        userData.user = userData.response_login.user;
        commit('SET_DATA', userData)
        commit('UPDATE_USER_DATA', userData.response_login.user);
      })
    },
    REGISTER(context, payloads) {
      context.commit('ERROR_STATUS', false)
      context.commit('ERROR_MSG', '')

      const formData = new FormData()

      Object.keys(payloads).forEach((key) => {
        if (key === 'driver_license') payloads[key] = JSON.stringify(payloads[key])
        formData.append(key, payloads[key])
      })

      return api.post(`${process.env.VUE_APP_API_URL}/create_user`, formData)
        .then((response) => {
          // A 200 can still carry error:true, so this check has to stay.
          if (response.data.data.error == true || response.data.data.error == 'true') {
            context.commit('ERROR_STATUS', true)
            context.commit('ERROR_MSG', response.data.data.message)
          }
        })
        .catch((error) => {
          context.commit('ERROR_STATUS', true)
          context.commit('ERROR_MSG', error.message)
        });
    },
    API_CALL({ commit, state }, payload) {
      const method = payload.$method;
      const postData = payload.$postData || {};
      delete payload.$method;
      delete payload.$postData;

      const { token } = state;

      // Session expiry used to be detected by string-matching the message the
      // server put in a fake HTTP 200. The interceptor in ../api surfaces it as
      // a rejection with apiCode 401, so the wording no longer matters.
      //
      // Anything else is handed back as the original response instead of a
      // rejection: the ~200 call sites of API_CALL already check
      // response.data.code themselves, and rejecting would silently skip them.
      const handleError = (error) => {
        if (isSessionExpired(error)) {
          commit('SET_LOGOUT_FROM_BUTTON', false);
          try {
            localStorage.removeItem(`USER_DATA_${STORAGE_NAME}`)
            localStorage.removeItem(`CLIENTID_${STORAGE_NAME}`)
          } catch (e) {}
          commit('REMOVE_DATA')
          window.location.reload()

          // Never settle. reload() does not stop the current tick, so resolving
          // here runs every in-flight caller's .then with undefined and each one
          // dies on `response.data` — that is the whole `reading 'data'` cluster
          // in Sentry (CARPOOLING-W/T/S/V, ~120 users). The page is going away.
          return new Promise(() => {})
        }
        if (error && error.response) return error.response;
        return Promise.reject(error);
      };

      if (postData.hasOwnProperty('uploadType')) {
        const formData = postData.data;
        delete postData.data;

        Object.keys(postData).forEach((key) => {
          formData.append(key, postData[key])
        })

        formData.append('token', token)

        const url = `${process.env.VUE_APP_API_URL}/${method}`
        return api.post(url, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          }
        })
          .then((response) => {
            commit('SET_LOGOUT_FROM_BUTTON', false);
            return response;
          })
          .catch(handleError)
      }
      else
      {
        const authPayload = { token, ...postData, ...payload };
        const query = qs.stringify(authPayload)
        const url   = `${process.env.VUE_APP_API_URL}/${method}`
        return api.post(url, query)
          .then((response) => response)
          .catch(handleError)
      }
    }
  }
})
